export default __webpack_public_path__ + "static/media/fish&chips-bold.7490ed33.woff2";